/*jslint white: true, plusplus: true, vars: true, undef: true, sloppy: true */
//"use strict";

/*
*   if used, each element style has a background style, background gradient and text
*   color.
*/
expocadfx.styles = {
    mainHeader : { clrBg: "#0073a8", clrText: "#FFFFFF", gradBg: "" },
    windowHeader : { clrBg: "#0073a8", clrText: "#FFFFFF", gradBg: "" },
    footer : { clrBg: "#0073a8", clrText: "#000000", gradBg: "" },
    exhibitor : { clrBg: "#83ADCF", clrText: "#FFFFFF", gradBg: "" },
    floorplan : { clrBg: "#4682B4", clrText: "#FFFFFF", gradBg: "" },   /* small layout only */
    home : { clrBg: "#4682B4", clrText: "#FFFFFF", gradBg: "" },
    category : { clrBg: "#4682B4", clrText: "#FFFFFF", gradBg: "" },
    pavilion : { clrBg: "#4682B4", clrText: "#FFFFFF", gradBg: "" },
    subShow : { clrBg: "#4682B4", clrText: "#FFFFFF", gradBg: "" },
    country : { clrBg: "#4682B4", clrText: "#FFFFFF", gradBg: "" },
    view : { clrBg: "#4682B4", clrText: "#FFFFFF", gradBg: "" },
    availableBooth : { clrBg: "#4682B4", clrText: "#FFFFFF", gradBg: "" },
    
    rows : { clrOddBg: "#D8EDF3", clrOddText: "#000000", clrEvenBg: "#F0F8FF", clrEvenText: "#000000"},
    fpToolbar: { clrBg: "#0073a8", clrText: "#FFFFFF", alpha: "1.0"}
    
};